import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { LinkContainer } from 'react-router-bootstrap';


import {
  Nav,
  Navbar,
  NavbarBrand,
  NavbarToggler,
  NavItem,
  Collapse,
  Container,
} from 'reactstrap';

// Local Deps
import lock from '../Auth/lock';
import { isLoggedIn } from '../Auth/utils';
import './TopNav.scss';
import TopNavAvatar from './TopNavAvatar'
import msgs from '../../config/messages';
import {
  homeRoute,
  toolingLocationListRoute,
  aboutRoute,
  contactRoute,
  supportRoute,
  solicitationsSearchRoute,
  registrationRoute,
  supplierCapabilitiesRoute,
} from '../../config/navigation/routes';
import { checkIfAuthIsValid } from '../../utils/authUtils';
import Logo from '../../images/LogowithoutWords.png';


export default class TopNav extends Component {
  static propTypes = {
    login: PropTypes.func.isRequired,
    logout: PropTypes.func.isRequired,
    auth: PropTypes.shape({
      jwtToken: PropTypes.string,
      expiration: PropTypes.number,
      permissions: PropTypes.array,
    }).isRequired,
    className: PropTypes.string,
    // originalOrgId: PropTypes.string,
    orgInfo: PropTypes.object,
    newMessage: PropTypes.bool.isRequired,
    newMessageCount: PropTypes.number.isRequired,
    isHomePage: PropTypes.bool,
  };

  static defaultProps = {
    className: '',
    // originalOrgId: null,
    orgInfo: null,
    isHomePage: false,
  };

  static initialState = {
    isOpen: false,
    visible: false,
    setTimeoutId: null,
  };

  state = TopNav.initialState;

  _toggle = isOpen => {
    this.setState({
      isOpen,
    });
  };

  render() {
    const {
      auth,
      login,
      logout,
      className,
      // originalOrgId,
      orgInfo,
      newMessage,
      newMessageCount,
      isHomePage,
    } = this.props;

    const isAuthenticated = checkIfAuthIsValid(auth);
    const avatar = <TopNavAvatar
      auth={auth}
      login={login}
      logout={logout}
      newMessage={newMessage}
      newMessageCount={newMessageCount}
      orgInfo={orgInfo}
      toggle={this._toggle}
    />
    return (
      <div className={`nf-top-nav ${className}`}>
        <Navbar data-pills expand="lg">
          <Container>
            <LinkContainer to={homeRoute} isActive={() => false}>
              <NavbarBrand>
                <img src={Logo} alt="Icon" className="nf-icon-logo" />
                <p className="navbar-brand-text">{msgs.TopNav.brandText}</p>
              </NavbarBrand>
            </LinkContainer>

            {/* Display here when navbar is not expanded */}
            {isAuthenticated && (
              <Nav id="avatarMenu1" className="nav--last">
                {avatar}
              </Nav>
            )}

            <NavbarToggler onClick={() => this._toggle(!this.state.isOpen)}>
              <i className="fa fa-bars" />
            </NavbarToggler>
            <Collapse isOpen={this.state.isOpen} navbar>
              <Nav>
                {isAuthenticated && (
                  <LinkContainer
                    to={solicitationsSearchRoute}
                    isActive={() => false}
                  >
                    <NavItem onClick={() => this._toggle(false)}>
                      {msgs.TopNav.item4}
                    </NavItem>
                  </LinkContainer>
                )}
                {isAuthenticated && (
                  <LinkContainer
                    to={toolingLocationListRoute}
                    isActive={() => false}
                  >
                    <NavItem onClick={() => this._toggle(false)}>
                      {msgs.TopNav.item1}
                    </NavItem>
                  </LinkContainer>
                )}
                {/* {isAuthenticated && (
                  <LinkContainer
                    to={procurementHistoryRoute}
                    isActive={() => false}
                  >
                    <NavItem onClick={() => this._toggle(false)}>
                      {msgs.TopNav.procurementHistory}
                    </NavItem>
                  </LinkContainer>
                )} */}
                {isAuthenticated && (
                  <LinkContainer
                    to={supplierCapabilitiesRoute}
                    isActive={() => false}
                  >
                    <NavItem onClick={() => this._toggle(false)}>
                      {msgs.TopNav.item5}
                    </NavItem>
                  </LinkContainer>
                )}
                {/* Show About and Contact links on the homepage for non-authenticated users */}
                {isHomePage && !isAuthenticated && (
                  <React.Fragment>
                    <LinkContainer to={aboutRoute} isActive={() => false}>
                      <NavItem onClick={() => this._toggle(false)}>
                        {msgs.TopNav.item2}
                      </NavItem>
                    </LinkContainer>
                    <LinkContainer to={contactRoute} isActive={() => false}>
                      <NavItem onClick={() => this._toggle(false)}>
                        {msgs.TopNav.item3}
                      </NavItem>
                    </LinkContainer>
                  </React.Fragment>
                )}

                {/* Show Support link for all users */}
                <LinkContainer to={supportRoute} isActive={() => false}>
                  <NavItem onClick={() => this._toggle(false)}>
                    Support
                  </NavItem>
                </LinkContainer>

                {!isAuthenticated && (
                  <LinkContainer to='#' isActive={() => false}>
                    <NavItem onClick={() => {
                      if (isLoggedIn(auth)) {
                        logout();
                      } else {
                        lock.show();
                        const authPromise = lock.getAuthorizedPromise ? lock.getAuthorizedPromise() : lock.authorizedPromise;
                        authPromise.then(jwtToken => {
                          login(jwtToken);
                        }).catch(error => {
                          console.error('Login error:', error);
                        });
                      }
                    }}
                    >
                      {isLoggedIn(auth) ? 'Logout' : 'Login'}
                    </NavItem>
                  </LinkContainer>
                )}

                {isLoggedIn(auth) ? null : (
                  <LinkContainer
                    to={registrationRoute}
                    isActive={() => false}
                    onClick={() => this._toggle(false)}
                  >
                    <NavItem>
                      {msgs.TopNav.userDropdown.register}
                    </NavItem>
                  </LinkContainer>
                )}
              </Nav>

            </Collapse>
            {/* Display here when navbar is expanded */}
            {isAuthenticated && (
              <Nav id="avatarMenu2" className="nav--last">
                {avatar}
              </Nav>
            )}

          </Container>
        </Navbar>
      </div >
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/TopNav/TopNav.jsx